import { Dataset, SortBy } from '../types'

export const StaticFolders = {
  favorites: 'favorites',
  all: 'all-datasets',
} as const

export type StaticFolders = (typeof StaticFolders)[keyof typeof StaticFolders]

export interface State {
  asc: boolean
  search: string
  selectedFolderId: number | string | null
  sortBy: SortBy
  filteredDatasets: Dataset[] | null
  selectedDataset: Dataset | null
}

export const ActionType = {
  setAsc: 'setAsc',
  setSearch: 'setSearch',
  setSelectedFolderId: 'setSelectedFolderId',
  setSortBy: 'setSortBy',
  reset: 'reset',
  setFilteredDatasets: 'setFilteredDatasets',
  setSelectedDataset: 'setSelectedDataset',
} as const

export type ActionType = (typeof ActionType)[keyof typeof ActionType]

export type Action =
  | { type: typeof ActionType.setAsc }
  | { type: typeof ActionType.setSearch; payload: string }
  | { type: typeof ActionType.setSelectedFolderId; payload: number | string | null }
  | { type: typeof ActionType.setSortBy; payload: SortBy }
  | { type: typeof ActionType.reset }
  | { type: typeof ActionType.setFilteredDatasets; payload: Dataset[] | null }
  | { type: typeof ActionType.setSelectedDataset; payload: Dataset | null }
